module.exports = __webpack_public_path__ + "media/images/covers/ha-top-bg-45c645e9b44202a3e7bf9bb7ea21fb28.jpg";